import React, { useState } from 'react';

import PermissionTooltip from '@dashboard/components/PermissionTooltip';
import { useCreateStripeCustomerPortalUrlMutation, WaypointFeatureTier } from '@dashboard/generated/wp/platform';
import { Box, Button, Link, Stack, Typography } from '@mui/material';

import { usePermission } from '../../hooks';

import BillingPlansDialog from './BillingPlansDialog';
import { getLabel } from './helpers';

type Props = {
  tier: WaypointFeatureTier;
};
export default function BillingPlanForm({ tier }: Props) {
  const [createStripeCustomerPortalUrl, { loading }] = useCreateStripeCustomerPortalUrlMutation();
  const permission = usePermission('updateSubscription');
  const [managePlanOpen, setManagePlanOpen] = useState(false);

  const onManageBillingClick = async () => {
    const { data } = await createStripeCustomerPortalUrl();
    if (data?.createStripeCustomerPortalUrl) {
      window.location.href = data.createStripeCustomerPortalUrl;
    }
  };
  const onManagePlanClick = () => {
    setManagePlanOpen(true);
  };

  let billingPlansDialog = null;
  if (managePlanOpen) {
    billingPlansDialog = <BillingPlansDialog tier={tier} onClose={() => setManagePlanOpen(false)} />;
  }

  let helperText = null;
  if (tier === WaypointFeatureTier.Free) {
    helperText = (
      <Box mt={1}>
        <Typography variant="body2" color="text.secondary">
          Learn about{' '}
          <Link href="https://www.usewaypoint.com/docs/trial-plan-limitations" target="_blank">
            trial plan limitations
          </Link>
          .
        </Typography>
      </Box>
    );
  }

  return (
    <Box component="fieldset">
      <Typography variant="overline" color="text.secondary">
        Plan
      </Typography>
      <Stack
        spacing={2}
        direction={{ xs: 'column', sm: 'row' }}
        justifyContent="space-between"
        alignItems={{ xs: 'flex-start', sm: 'center' }}
        sx={{ p: 2, bgcolor: 'cadet.200', border: '1px solid', borderColor: 'cadet.300' }}
      >
        <Typography fontWeight="medium">{getLabel(tier)}</Typography>

        <PermissionTooltip span name="updateSubscription">
          <Stack spacing={1} direction="row">
            <Button variant="contained" color="secondary" onClick={onManagePlanClick} size="small">
              Manage plan
            </Button>
            <Button
              disabled={loading || !permission}
              variant="contained"
              color="secondary"
              onClick={onManageBillingClick}
              size="small"
            >
              Manage billing
            </Button>
          </Stack>
        </PermissionTooltip>
      </Stack>
      {helperText}
      {billingPlansDialog}
    </Box>
  );
}
